import { Dropdown, Tooltip } from 'antd';
import authApi from 'api/auth';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
// import NotificationIcon from 'assets/icons/NotificationIcon';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
// import ExternalLinkIcon from 'assets/icons/ExternalLinkIcon';
// import LinkIcon from 'assets/icons/LinkIcon';

import terabet_logo from 'assets/images/new_logo1.png';
import ConditionButton from 'components/Commons/ConditionButton';
import { IMG_ALT } from 'consts/app';
// import DepositModal from 'features/home/components/Modals/DepositModal';
import PromotionModal from 'features/home/components/Modals/PromotionModal';
import UserProfileModal from 'features/home/components/Modals/UserProfileModal';
// import WithdrawModal from 'features/home/components/Modals/WithdrawModal';
import AccountSubMenu from 'features/home/components/Submenu/AccountSubMenu';
import {
  onChangeAuthPage,
  selectEvent,
  selectSearch,
  setAssets,
  setBlance,
  setCoins,
  setGames,
  setSearch,
  setShowEventNoti,
} from 'features/home/homeSlice';
import { useHandleGetWallets } from 'hooks/useHandleGetWallets';
import useThemes from 'hooks/useThemes';
import useUserDetail from 'hooks/useUserDetail';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
// import { LiaLinkSolid } from 'react-icons/lia';
import { showInfoModal } from 'components/Modals/CommonModals';
// import AchDebitDepositModal from 'features/home/components/Modals/AchDebitDepositModal';
import CashierModal from 'features/home/components/Modals/CashierModal';
// import CryptoWalletDepositModal from 'features/home/components/Modals/CryptoWalletDepositModal';
// import CryptoWalletWithdrawModal from 'features/home/components/Modals/CryptoWalletWithdrawModal';
// import FiatWithdrawModal from 'features/home/components/Modals/FiatWithdrawModal';
// import PaymentMethodsModal from 'features/home/components/Modals/PaymentMethodsModal';
// import SwapModal from 'features/home/components/Modals/SwapModal';
// import UserBankbookModal from 'features/home/components/Modals/UserBankbookModal';
// import VinpayDepositModal from 'features/home/components/Modals/VinpayDepositModal';
// import VinpayWithdrawModal from 'features/home/components/Modals/VinpayWithdrawModal';
// import WalletConnectModal from 'features/home/components/Modals/WalletConnectModal';
import gameApi from 'api/gameApi';
import streamApi from 'api/streamApi';
import casino from 'assets/icons/casino_icon.png';
import casino_dark from 'assets/icons/casino_icon_dark.png';
import home from 'assets/icons/home_icon.png';
import home_dark from 'assets/icons/home_icon_dark.png';
import poker from 'assets/icons/poker_icon.png';
import ServiceMenuBar from 'features/chatRoom/components/ServiceMenuBar';
import SearchItem from 'features/home/components/SearchItem';
import SettingSubMenu from 'features/home/components/Submenu/SettingSubMenu';
import TabCategory from 'features/home/components/TabCategory';
import { StreamResponse } from 'models/stream';
import { CgLogIn } from 'react-icons/cg';
import { CiStreamOn } from 'react-icons/ci';
import { FaRegUser, FaUser, FaWallet } from 'react-icons/fa';
import { IoSettingsOutline, IoSettingsSharp } from 'react-icons/io5';
import { MdDarkMode, MdLightMode, MdOutlineArrowBack } from 'react-icons/md';
import { TbFileDescription } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import { platformStates } from 'redux/platformSlice';
import { setClearStateToLogout } from 'redux/userSlice';
import { isLaptop, isPhone, isTablet } from 'utils/commonUtils';
import { getLocalStorage, removeLocalStorage } from 'utils/sessionStorage';
import CurrencySwicher from './CurrencySwitcher';
import LanguageDropdown from './LanguageDropdown';
import LoadingSpinner from './LoadingSpinner';
import LiveIcon from 'assets/icons/LiveIcon';

export interface HeaderProps {
  onShowChangePasswordPage: () => void;
  isCasino?: boolean;
  isStreaming?: boolean;
  isShowAllPage?: boolean;
  isShowAllStreaming?: boolean;
  isHomeScreen?: boolean;
}

export interface ShowModalProps {
  vinpayConnect: boolean;
  depositModal: number;
  isDeposit: boolean;
  paymentMethodsModal: boolean;
  achDebitDepositModal: boolean;
  withdrawModal: boolean;
  fiatWithdrawModal: boolean;
  promotionModal: boolean;
  support: boolean;
  transferModal: boolean;
  eventModal: boolean;
  headerMenu: boolean;
  userProfile: boolean;
  userBankbookModal: boolean;
  cryptoWalletDepositModal: boolean;
  cryptoWalletWithdrawModal: boolean;
  vinpayDepositModal: boolean;
  vinpayWithdrawModal: boolean;
  walletConnectModal: boolean;
  tbetBuySellModal: boolean;
  cashierModal: boolean;
}

// interface SupportLink {
//   title: string;
//   url: string;
// }

// const supportLinks: SupportLink[] = [
//   {
//     title: 'Pinnacle',
//     url: 'https://pinnaclesports.com/',
//   },
//   {
//     title: 'Betcris',
//     url: 'https://betcris.com/',
//   },
//   {
//     title: 'Stake',
//     url: 'https://stake.com/',
//   },
//   {
//     title: 'Bet365',
//     url: 'https://www.bet365.com/',
//   },
//   {
//     title: 'Sbobet',
//     url: 'http://www.sbobet.com/',
//   },
// ];
const initialState = {
  depositModal: 0,
  isDeposit: true,
  paymentMethodsModal: false,
  achDebitDepositModal: false,
  withdrawModal: false,
  fiatWithdrawModal: false,
  promotionModal: false,
  support: false,
  transferModal: false,
  eventModal: false,
  headerMenu: false,
  userProfile: false,
  userBankbookModal: false,
  cryptoWalletDepositModal: false,
  cryptoWalletWithdrawModal: false,
  vinpayDepositModal: false,
  vinpayWithdrawModal: false,
  walletConnectModal: false,
  tbetBuySellModal: false,
  cashierModal: false,
  vinpayConnect: false,
};

const Header: React.FunctionComponent<HeaderProps> = ({
  onShowChangePasswordPage,
  isCasino = false,
  isShowAllPage = false,
  isStreaming = false,
  isShowAllStreaming = false,
  isHomeScreen = false,
}) => {
  const eventSelected = useAppSelector(selectEvent);
  const { currentTheme, toggleDarkMode } = useThemes();
  const t = useAppTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { coins, assets, fetchData } = useHandleGetWallets();
  const { isUserLoggedIn, getUserDetail, getUser } = useUserDetail();
  const accessToken = getLocalStorage('access_token_terabet');
  const platform = useAppSelector(platformStates);

  const divLinksRef = useRef<HTMLDivElement>(null);
  const divLinkMobileRef = useRef<HTMLDivElement>(null);
  const divHeaderMenuRef = useRef<HTMLDivElement>(null);
  // const [isShowRankingInMobile, setIsShowRankingInMobile] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<ShowModalProps>(initialState);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [streamChanels, setStreamChanels] = useState<StreamResponse[] | null>();
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const search = useAppSelector(selectSearch);
  const handleDocumentClick = (event: MouseEvent) => {
    event.stopPropagation();

    if (divHeaderMenuRef.current && !divHeaderMenuRef.current.contains(event.target as Node)) {
      handleSetShowModal('headerMenu', false);
    } else handleSetShowModal('headerMenu', !showModal.headerMenu);

    if (
      divLinksRef.current &&
      !divLinksRef.current.contains(event.target as Node) &&
      divLinkMobileRef.current &&
      !divLinkMobileRef.current.contains(event.target as Node)
    ) {
      handleSetShowModal('support', false);
    } else handleSetShowModal('support', !showModal.headerMenu);
  };

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isUserLoggedIn) {
      getUser();
    }
    fetchData();
  }, [isUserLoggedIn]);

  useEffect(() => {
    dispatch(setCoins(coins));
    dispatch(setAssets(assets));
  }, [coins, assets, dispatch]);

  const logout = async () => {
    const { ok, error } = await authApi.logout({
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (ok) {
      dispatch(setClearStateToLogout());
    }
    if (error && error.unauthorized) {
      dispatch(setClearStateToLogout());
    }
    dispatch(setBlance('0'));
    removeLocalStorage('access_token_terabet');
    removeLocalStorage('kyc_access_token_terabet');
    getUserDetail();
  };

  const handleLogoClick = (): void => {
    navigate('/');
  };

  const handleDepositClick = () => {
    switch (showModal.depositModal) {
      case 1:
        handleSetShowModal('depositModal', 2);
        break;
      case 0:
        handleSetShowModal('depositModal', 1);
        break;
      default:
        handleSetShowModal('depositModal', 0);
        break;
    }
  };
  const handleWithdrawClick = () => {
    handleSetShowModal('withdrawModal', !showModal.withdrawModal);
  };

  const handleFiatWithdrawClick = () => {
    handleSetShowModal('fiatWithdrawModal', !showModal.fiatWithdrawModal);
  };

  const handlePromotionClick = () => {
    handleSetShowModal('promotionModal', !showModal.promotionModal);
  };

  const handleUserBankbookClick = () => {
    handleSetShowModal('userBankbookModal', !showModal.userBankbookModal);
  };

  const handleEventClick = () => {
    handleSetShowModal('eventModal', !showModal.eventModal);
  };

  const handleUserProfileClick = () => {
    handleSetShowModal('userProfile', !showModal.userProfile);
  };

  const handleAchDebitDepositClick = () => {
    handleSetShowModal('achDebitDepositModal', !showModal.achDebitDepositModal);
  };

  const handleCryptoWalletDepositClick = () => {
    handleSetShowModal('cryptoWalletDepositModal', !showModal.cryptoWalletDepositModal);
  };

  const handleCryptoWalletWithdrawClick = () => {
    handleSetShowModal('cryptoWalletWithdrawModal', !showModal.cryptoWalletWithdrawModal);
  };

  const handleVinpayDepositClick = () => {
    handleSetShowModal('vinpayDepositModal', !showModal.vinpayDepositModal);
  };

  const handleVinpayWithdrawClick = () => {
    handleSetShowModal('vinpayWithdrawModal', !showModal.vinpayWithdrawModal);
  };

  const handleWalletConnectClick = () => {
    handleSetShowModal('walletConnectModal', !showModal.walletConnectModal);
  };

  const handleTbetBuySellClick = () => {
    handleSetShowModal('tbetBuySellModal', !showModal.tbetBuySellModal);
  };

  const onShowLoginPage = () => {
    dispatch(onChangeAuthPage(0));
  };

  const onShowSignUpPage = () => {
    dispatch(onChangeAuthPage(1));
  };

  const handleCasinoClick = () => {
    navigate('/casino');
  };

  const handleStreamingClick = () => {
    navigate('/streaming');
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleBackClick = () => {
    navigate('/casino');
  };

  const handleBackStreamingClick = () => {
    navigate(-1);
  };

  const handlePokerClick = async () => {
    if (!isUserLoggedIn) {
      window.open(process.env.REACT_APP_POKER_URL, '_blank');
      return;
    }
    setIsLoading(true);
    // window.open(`${window.location.host}/casino/game/poker/play`, '_blank');
    const { ok, body, error } = await gameApi.playPoker();
    setIsLoading(false);
    if (ok && body) {
      window.open(body.url, '_blank');
    }
  };

  const handleSetShowModal = (key: keyof ShowModalProps, value: boolean | number) => {
    setShowModal((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          url: 'https://terabet.io/',
          title: 'Terabet',
        });
      } else {
        console.error('Web Share API not supported');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  const handlePaymentMethodClick = (id: number) => {
    switch (id) {
      case 0:
        handleClosePaymentMethod();
        handleSetShowModal('depositModal', 2);
        break;
      case 3:
        handleClosePaymentMethod();
        handleVinpayDepositClick();
        break;
      case 4:
        handleClosePaymentMethod();
        handleAchDebitDepositClick();
        break;
      case 5:
        handleClosePaymentMethod();
        handleWithdrawClick();
        break;
      case 6:
        handleClosePaymentMethod();
        handleFiatWithdrawClick();
        break;
      case 7:
        handleClosePaymentMethod();
        handleCryptoWalletDepositClick();
        break;
      case 8:
        handleClosePaymentMethod();
        handleCryptoWalletWithdrawClick();
        break;
      case 9:
        handleClosePaymentMethod();
        handleVinpayWithdrawClick();
        break;
      default:
        showInfoModal({
          title: t('popup.comingSoon.title'),
          content: t('popup.comingSoon.content'),
        });
        break;
    }
  };

  const handleOpenPaymentMethod = (isDeposit: boolean) => {
    setShowModal((prev) => ({
      ...prev,
      isDeposit,
      paymentMethodsModal: true,
    }));
  };

  const handleClosePaymentMethod = () => {
    setShowModal((prev) => ({
      ...prev,
      paymentMethodsModal: false,
    }));
  };

  const handleCashierClick = () => {
    if (isUserLoggedIn) {
      handleSetShowModal('cashierModal', !showModal.cashierModal);
    } else {
      dispatch(onChangeAuthPage(0));
    }
  };

  const getStreamLink = async () => {
    const { ok, body } = await streamApi.getStreams();
    if (ok && body) {
      setStreamChanels(body);
    }
  };

  useEffect(() => {
    getStreamLink();
  }, []);

  const streaming = useMemo(() => {
    if (streamChanels) {
      return streamChanels.some((s) => s.chanelLink !== '') || false;
    }
    return false;
  }, [streamChanels]);

  const handleShowEventNoti = () => {
    if (eventSelected) {
      dispatch(setShowEventNoti(true));
    } else {
      showInfoModal({
        title: t('popup.comingSoon.title'),
        content: t('popup.comingSoon.content'),
      });
    }
  };

  const onPressEnter = (value: string) => {
    dispatch(
      setSearch({
        searchText: value,
        isSearchLayout: !!value,
      }),
    );
    dispatch(setGames(undefined));
  };

  const handleSearch = () => {
    if (search.searchText) {
      dispatch(setSearch({ searchText: '', isSearchLayout: false }));
    }
    setShowSearch((prev) => !prev);
  };

  return (
    <>
      <div className="main-header">
        {/* {window.innerWidth < 1025 && (
          <div className={`overlay ${isShowRankingInMobile ? '' : 'hidden'}`}>
            <div className="user-ranking-mobile">
              <button
                className="btn-close"
                onClick={() => setIsShowRankingInMobile(false)}
                type="button"
              >
                <AiOutlineCloseCircle />
              </button>
              <UserRanking isMobile isReload={isShowRankingInMobile} />
            </div>
          </div>
        )} */}

        <div className="flex justify-between items-center w-full">
          {!(isCasino || isStreaming || isShowAllStreaming) && (
            <div className="searchBar">
              <div className="search-bar">
                <button className="authen-button" onClick={handleSearch}>
                  {showSearch ? (
                    <CloseOutlined className="search-icon" />
                  ) : (
                    <SearchOutlined className="search-icon" />
                  )}
                </button>
                {showSearch && <SearchItem onSubmit={onPressEnter} />}
              </div>
            </div>
          )}

          {!(isPhone(platform) || isTablet(platform) || isLaptop(platform)) &&
            !(isCasino || isStreaming || isShowAllStreaming) && <TabCategory />}
          <div className="header-image">
            <img
              src={terabet_logo}
              alt={IMG_ALT}
              className="cursor-pointer"
              onClick={handleLogoClick}
            />
            <Tooltip placement="bottom" title={t('header.stream')} showArrow={false}>
              <div className="stream-button header_stream" onClick={handleStreamingClick}>
                <LiveIcon className={`w-6 h-6 streaming-svg`} />
              </div>
            </Tooltip>
          </div>
          {!(isCasino || isStreaming || isShowAllStreaming) && (
            <ServiceMenuBar onShowChangePasswordPage={onShowChangePasswordPage} />
          )}
          {/* <div className="flex-row gap-2 currenctySwitch">
            {isUserLoggedIn && (
              <div className="gap-2">
                <CurrencySwicher />
              </div>
            )}
          </div> */}
          <div className="items-center header__controls">
            {isUserLoggedIn && (
              <div className="flex-row items-center gap-2">
                {/* <span className={`primary-text-color ${Typo.p5}`}>
                  {`${formatMoney(balance, 0)}`}
                </span> */}
                <CurrencySwicher />
              </div>
            )}
            {/* <button
              className="header-icon ranking-button"
              onClick={() => setIsShowRankingInMobile(true)}
            >
              <img
                src={currentTheme === 'dark' ? ranking_icon : ranking_icon_dark}
                alt={IMG_ALT}
                className="w-4 h-4"
              />
            </button> */}
            <LanguageDropdown />
            <button
              id="btn-change-theme"
              className="header-icon cursor-pointer"
              onClick={toggleDarkMode}
            >
              {currentTheme === 'light' ? (
                <MdDarkMode className="primary-text-color w-5 h-5" />
              ) : (
                <MdLightMode className="primary-text-color w-5 h-5" />
              )}
            </button>
            {/* <div className="header-icon relative ranking-button" ref={divHeaderMenuRef}>
              <img
                src={currentTheme === 'dark' ? menu_icon : menu_icon_dark}
                alt={IMG_ALT}
                className="w-4 h-4"
              />
              <div
                className={`header__menu--mobile ${showModal.headerMenu ? 'scale-100' : 'scale-0'}`}
              >
                <div className="relative" ref={divLinkMobileRef}>
                  <button className="header__menu--mobile__item">
                    <LiaLinkSolid className="primary-text-color w-5 h-5" />
                    <span className="primary-text-color">Links</span>
                  </button>
                  <div
                    style={{ right: '78px', top: 0 }}
                    className={`links-mobile ${showModal.support ? 'scale-100' : 'scale-0'}`}
                  >
                    {supportLinks.map((link, index) => (
                      <a
                        key={`links-${index}`}
                        href={link.url}
                        target="__blank"
                        className="flex-row items-center gap-2 primary-text-color"
                      >
                        {link.title}
                        <ExternalLinkIcon
                          isDarkmode={currentTheme === 'dark'}
                          width="16"
                          height="16"
                        />
                      </a>
                    ))}
                  </div>
                </div>
                <button className="header__menu--mobile__item" onClick={handleShare}>
                  <FaShare className="primary-text-color w-5 h-5" />
                  <span className="primary-text-color">Share</span>
                </button>
                <a href="mailto:support@terabet.io" className="header__menu--mobile__item">
                  <FaHeadphones className="primary-text-color w-5 h-5" />
                  <span className="primary-text-color">Support</span>
                </a>
                <button className="header__menu--mobile__item" onClick={toggleDarkMode}>
                  {currentTheme === 'light' ? (
                    <MdLightMode className="primary-text-color w-5 h-5" />
                  ) : (
                    <MdDarkMode className="primary-text-color w-5 h-5" />
                  )}
                  <span className="primary-text-color">
                    {currentTheme === 'dark' ? 'Dark mode' : 'Light mode'}
                  </span>
                </button>
              </div>
            </div> */}
          </div>
        </div>
        {!isHomeScreen && (
          <div className="">
            <div className={`authen-link ${isUserLoggedIn ? 'justify-between' : 'justify-end'}`}>
              {!isCasino ? (
                <Fragment>
                  <div className="authen-button-container">
                    <ConditionButton
                      className="authen-button"
                      onClick={handleCasinoClick}
                      content={
                        <img
                          src={currentTheme === 'dark' ? casino : casino_dark}
                          alt={IMG_ALT}
                          className="w-5 h-5"
                        />
                      }
                      isSkipCheckOnClick
                    />
                    <p className="primary-text-color font-bold"> {t('header.casino')}</p>
                  </div>
                </Fragment>
              ) : (
                <div className="authen-button-container">
                  <ConditionButton
                    className="authen-button"
                    onClick={handleHomeClick}
                    content={
                      <img
                        src={currentTheme === 'dark' ? home : home_dark}
                        alt={IMG_ALT}
                        className="w-5 h-5"
                      />
                    }
                    isSkipCheckOnClick
                  />
                  <p className="primary-text-color font-bold"> {t('header.home')}</p>
                </div>
              )}
              {!isStreaming ? (
                <Fragment>
                  <div className="authen-button-container">
                    <ConditionButton
                      className="authen-button"
                      onClick={handleStreamingClick}
                      content={
                        <CiStreamOn className={`w-5 h-5 ${streaming ? 'streaming-svg' : ''}`} />
                      }
                      isSkipCheckOnClick
                    />
                    <p className="primary-text-color font-bold"> {t('header.stream')}</p>
                  </div>
                </Fragment>
              ) : (
                <div className="authen-button-container">
                  <ConditionButton
                    className="authen-button"
                    onClick={handleHomeClick}
                    content={
                      <img
                        src={currentTheme === 'dark' ? home : home_dark}
                        alt={IMG_ALT}
                        className="w-5 h-5"
                      />
                    }
                    isSkipCheckOnClick
                  />
                  <p className="primary-text-color font-bold"> {t('header.home')}</p>
                </div>
              )}

              <div className="authen-button-container">
                <ConditionButton
                  className="authen-button"
                  onClick={handlePokerClick}
                  content={<img src={poker} alt={IMG_ALT} className="w-5 h-5" />}
                  isSkipCheckOnClick
                />
                <p className="primary-text-color font-bold"> {t('header.poker')}</p>
              </div>
              {isShowAllPage && (
                <div className="authen-button-container">
                  <ConditionButton
                    className="authen-button"
                    onClick={handleBackClick}
                    content={<MdOutlineArrowBack className="w-5 h-5" />}
                    isSkipCheckOnClick
                  />
                  <p className="primary-text-color font-bold"> {t('header.back')}</p>
                </div>
              )}
              {isShowAllStreaming && (
                <div className="authen-button-container">
                  <ConditionButton
                    className="authen-button"
                    onClick={handleBackStreamingClick}
                    content={<MdOutlineArrowBack className="w-5 h-5" />}
                    isSkipCheckOnClick
                  />
                  <p className="primary-text-color font-bold"> {t('header.back')}</p>
                </div>
              )}

              <div className="authen-link__left">
                {(!isCasino || !isStreaming || !isShowAllStreaming) && (
                  <Fragment>
                    {/* <ConditionButton
                  onClick={() => handleOpenPaymentMethod(true)}
                  className="authen-button"
                  content={t('deposit.title')}
                  isSkipCheckOnClick={!isUserLoggedIn}
                />

                <ConditionButton
                  content={t('withdraw.title')}
                  onClick={() => handleOpenPaymentMethod(false)}
                  className="authen-button"
                  name="Withdraw"
                  isSkipCheckOnClick={!isUserLoggedIn}
                />
                <ConditionButton
                  onClick={() => handleTbetBuySellClick()}
                  className="authen-button"
                  content={t('tbet.buy.button')}
                  isSkipCheckOnClick={!isUserLoggedIn}
                /> */}
                    <div className="authen-button-container">
                      <ConditionButton
                        onClick={() => handleCashierClick()}
                        className="authen-button"
                        content={<FaWallet className="w-5 h-5" />}
                        testerCheck={true}
                        isSkipCheckOnClick={!isUserLoggedIn}
                      />

                      <p className="primary-text-color font-bold">
                        {' '}
                        {t('footerMenu.cashier.title')}
                      </p>
                    </div>
                  </Fragment>
                )}

                {!isUserLoggedIn && (
                  <div className="flex-row">
                    <div className="authen-button-container">
                      <button
                        id="btn-change-theme"
                        className="header-icon cursor-pointer"
                        onClick={onShowLoginPage}
                      >
                        <CgLogIn className=" primary-text-color w-5 h-5" />
                      </button>
                      <p className="primary-text-color font-bold"> {t('header.login')}</p>
                    </div>
                    <div className="authen-button-container">
                      <button
                        id="btn-change-theme"
                        className="header-icon cursor-pointer"
                        onClick={onShowSignUpPage}
                      >
                        <TbFileDescription className="w-5 h-5 primary-text-color" />
                      </button>
                      <p className="primary-text-color font-bold"> {t('header.register')}</p>
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="header-icon cursor-pointer" ref={divLinksRef}>
            <LinkIcon isDarkMode={currentTheme === 'dark'} />
            <div className={`links ${showModal.support ? 'scale-100' : 'scale-0'}`}>
              {supportLinks.map((link) => (
                <a
                  key={uniqueId()}
                  href={link.url}
                  target="__blank"
                  className="flex-row items-center gap-2 primary-text-color"
                >
                  {link.title}
                  <ExternalLinkIcon
                    isDarkmode={currentTheme === 'dark'}
                    className="primary-text-color"
                    width="16"
                    height="16"
                  />
                </a>
              ))}
            </div>
          </div> */}
              {/* <div className="authen-button-container">
                <a href="mailto:support@terabet.io" className="header-icon cursor-pointer">
                  <HeadPhoneIcon isDarkMode={currentTheme === 'dark'} />
                </a>
                <p className="primary-text-color font-bold"> {t('footerMenu.support')}</p>
              </div>
              <div className="authen-button-container">
                <LanguageDropdown />
                <p className="primary-text-color font-bold"> {t('footerMenu.language')}</p>
              </div>
             */}
              <div className="authen-button-container">
                <button className="header-icon cursor-pointer" onClick={toggleDarkMode}>
                  {currentTheme === 'light' ? (
                    <MdDarkMode className="primary-text-color w-5 h-5" />
                  ) : (
                    <MdLightMode className="primary-text-color w-5 h-5" />
                  )}
                </button>
                <p className="primary-text-color font-bold"> {t('footerMenu.theme')}</p>
              </div>
              <Dropdown trigger={['click']} overlay={<SettingSubMenu />}>
                <div className="authen-button-container">
                  <button className="header-icon cursor-pointer">
                    {currentTheme === 'light' ? (
                      <IoSettingsOutline className="primary-text-color w-5 h-5" />
                    ) : (
                      <IoSettingsSharp className="primary-text-color w-5 h-5" />
                    )}
                  </button>
                  <p className="primary-text-color font-bold">{t('footerMenu.setting')}</p>
                </div>
              </Dropdown>
              {isUserLoggedIn ? (
                <>
                  <Dropdown
                    trigger={['click']}
                    overlay={
                      <AccountSubMenu
                        handlePromotionClick={handlePromotionClick}
                        handleEventClick={handleEventClick}
                        handleUserProfileClick={handleUserProfileClick}
                        handleUserBankbookClick={handleUserBankbookClick}
                        handleWalletConnectClick={handleWalletConnectClick}
                        logout={logout}
                      />
                    }
                  >
                    {/* <Button className="drop-down-btn ">
                    {t('header.account')} <DownOutlined />
                  </Button> */}
                    <div className="authen-button-container">
                      <button className="header-icon cursor-pointer">
                        {currentTheme === 'light' ? (
                          <FaUser className="primary-text-color w-5 h-5" />
                        ) : (
                          <FaRegUser className="primary-text-color w-5 h-5" />
                        )}
                      </button>
                      <p className="primary-text-color font-bold"> {t('footerMenu.account')}</p>
                    </div>
                  </Dropdown>
                </>
              ) : null}
            </div>
          </div>
        )}
      </div>
      {/* <DepositModal
        title={t('deposit.title')}
        visible={showModal.depositModal === 2}
        closeModal={() => handleSetShowModal('depositModal', 0)}
        className="common-modal deposit-modal"
      />
      <AchDebitDepositModal
        title={t('deposit.title')}
        visible={showModal.achDebitDepositModal}
        closeModal={handleAchDebitDepositClick}
        className="common-modal withdraw-modal"
      />
      <CryptoWalletDepositModal
        title={t('deposit.title')}
        visible={showModal.cryptoWalletDepositModal}
        closeModal={handleCryptoWalletDepositClick}
        className="common-modal withdraw-modal"
      />
      <VinpayDepositModal
        title={t('deposit.title')}
        visible={showModal.vinpayDepositModal}
        closeModal={handleVinpayDepositClick}
        className="common-modal withdraw-modal"
      />
      <FiatWithdrawModal
        title={t('withdraw.title')}
        visible={showModal.fiatWithdrawModal}
        closeModal={handleFiatWithdrawClick}
        className="common-modal withdraw-modal"
      />
      <WithdrawModal
        title={t('withdraw.title')}
        visible={showModal.withdrawModal}
        closeModal={handleWithdrawClick}
        className="common-modal withdraw-modal"
      />
      <CryptoWalletWithdrawModal
        title={t('withdraw.title')}
        visible={showModal.cryptoWalletWithdrawModal}
        closeModal={handleCryptoWalletWithdrawClick}
        className="common-modal withdraw-modal"
      />
      <VinpayWithdrawModal
        title={t('withdraw.title')}
        visible={showModal.vinpayWithdrawModal}
        closeModal={handleVinpayWithdrawClick}
        className="common-modal withdraw-modal"
      />
      <PromotionModal
        title={t('promotion.title')}
        visible={showModal.promotionModal}
        closeModal={handlePromotionClick}
        className="common-modal withdraw-modal"
      /> */}
      {/* <TransferModal
        visible={showModal.transferModal}
        closeModal={handleTransferClick}
        title={t('transfer.title')}
        className="common-modal withdraw-modal"
      /> */}
      {/* <EventModal
        title={t('event.title')}
        visible={showModal.eventModal}
        closeModal={handleEventClick}
        className="common-modal withdraw-modal"
      /> */}
      <PromotionModal
        title={t('promotion.title')}
        visible={showModal.promotionModal}
        closeModal={handlePromotionClick}
        className="common-modal withdraw-modal"
      />
      <UserProfileModal
        title={t('userProfile.title')}
        visible={showModal.userProfile}
        closeModal={handleUserProfileClick}
        onShowChangePasswordPage={onShowChangePasswordPage}
      />
      {/* <PaymentMethodsModal
        isOpen={showModal.paymentMethodsModal}
        handlePaymentMethodClick={handlePaymentMethodClick}
        onCancel={handleClosePaymentMethod}
        type={showModal.isDeposit ? 'deposit' : 'withdraw'}
      />
      <UserBankbookModal
        title={t('accountSubMenu.bankbook')}
        visible={showModal.userBankbookModal}
        closeModal={handleUserBankbookClick}
        className="common-modal withdraw-modal"
      />
      <UserBankbookModal
        title={t('accountSubMenu.bankbook')}
        visible={showModal.userBankbookModal}
        closeModal={handleUserBankbookClick}
        className="common-modal withdraw-modal"
      />
      <WalletConnectModal
        isOpen={showModal.walletConnectModal}
        onCancel={handleWalletConnectClick}
      />
      <SwapModal
        title={t('tbet.buy.button')}
        visible={showModal.tbetBuySellModal}
        closeModal={handleTbetBuySellClick}
        className="common-modal withdraw-modal"
      /> */}
      <CashierModal
        isOpen={showModal.cashierModal}
        onCancel={handleCashierClick}
        onClose={() => handleSetShowModal('cashierModal', false)}
      />
      {isLoading && (
        <div className="overlay">
          <LoadingSpinner />
        </div>
      )}
    </>
  );
};

export default Header;
